"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zero = void 0;
exports.zero = {
    Address: 'MultiAddress',
    LookupSource: 'MultiAddress',
    AccountInfo: 'AccountInfoWithDualRefCount',
    AccountInfoWithDualRefCount: {
        nonce: 'Index',
        consumers: 'RefCount',
        providers: 'RefCount',
        data: 'AccountData',
    },
    Timestamp: 'Moment',
};
